import { Button, Center, Flex, Icon, Link, Text } from "@chakra-ui/react";
import { AiOutlineFileSearch } from "react-icons/ai";
import { Link as ReactLink } from "react-router-dom";
import { Permission, visitasFunc, motivoFunc, servicoAcolhimentoFunc } from "../../../helpers/Funcionalidades"
import React from "react";
import { useAuthProvider } from "../../../Context/AuthProvider";

export default function SemRegistros(props) {

    const { entidade, loading, buttonVisible, half, data, name } = props;
    const { roleKeycloack } = useAuthProvider();
    return (
        <Center bg={"white"} display={loading ? "none" : "flex"} minH={half ? "10vh" : "75vh"} color="black" rounded={20} boxShadow={40} >
            <Flex flexDir={"column"}>
                <Flex mb={5} ml={[16, 20]} flexDir={"column"} alignContent={"center"} mt={props.crianca && 4} >
                    <Icon as={AiOutlineFileSearch} color={"gray.300"} fontSize={"9xl"} />
                </Flex>

                <Flex mb={5}>
                    <Text textAlign={"center"} fontSize={["xl", "2xl"]}>Não há registros disponíveis</Text>
                </Flex>
                {entidade === "visitas" || entidade === "motivo-situacao" || entidade === "servico-acolhimento" ? (
                    <Permission
                        roleKeycloack={roleKeycloack}
                        func={
                            entidade === "visitas"
                                ? visitasFunc.visitaCadastrar
                                : entidade === "motivo-situacao"
                                    ? motivoFunc.motivoCadastrar
                                    : entidade === 'servico-acolhimento'
                                        ? servicoAcolhimentoFunc.cadastrar
                                        : ""
                        }>
                        <Link
                            mb={props.crianca && 4}
                            as={ReactLink}
                            to={"/" + entidade + "/cadastrar"} _hover={{ textDecoration: "none" }} w={"100%"}>
                            {buttonVisible ? "" : <Button px={10} mt={["5", "0"]} w={["100%", "100%"]} size="md" backgroundColor="#169499" colorScheme="teal">
                                Cadastrar
                            </Button>}

                        </Link>
                    </Permission>
                ) : <Link
                    display={buttonVisible ? "none" : "block"}
                    mb={props.crianca && 4}
                    as={ReactLink}
                    to={data && name ? "/" + entidade + "/cadastrar?nome=" + name : "/" + entidade + "/cadastrar"} _hover={{ textDecoration: "none" }} w={"100%"}>
                    {buttonVisible ? "" : <Button px={10} mt={["5", "0"]} w={["100%", "100%"]} size="md" backgroundColor="#169499" colorScheme="teal">
                        Cadastrar
                    </Button>
                    }

                </Link>}

            </Flex>
        </Center >
    )

}